import React from 'react';

// VendorAvatar — a circular monogram (first letter of the vendor's name/label)
// on a soft brand-tinted disc. Gives vendor rows an identity cue like the
// reference design without needing per-vendor logos. Purely decorative, so it
// is aria-hidden; the adjacent name is the accessible label.
//
// Props:
//   label — text whose first character becomes the monogram
//   size  — disc diameter in px (default 34)
function VendorAvatar({ label, size = 34 }) {
    const initial = (label || '?').trim().charAt(0).toUpperCase() || '?';
    return (
        <span
            aria-hidden="true"
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                flexShrink: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--color-primary-soft, #E8EEF6)',
                color: 'var(--color-primary)',
                fontWeight: 700,
                fontSize: Math.round(size * 0.38),
            }}
        >
            {initial}
        </span>
    );
}

export default VendorAvatar;
